import { useEffect, useRef, useState, useMemo } from 'react';
import { UserMenuItems } from './UserMenuItems';
import { cn } from '../client/cn';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';


const getStoreName = (storeName: string | undefined) => {
  if (storeName && storeName.includes("default")) {
    return "Your Store";
  } else if (storeName) {
    return storeName;
  } else {
    return "Your Store";
  }
};

const DropdownUser = () => {
  const { currentCollection } = useSelector((state: RootState) => state.user);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const storeName = getStoreName(currentCollection?.collection?.name)

  const trigger = useRef<any>(null);
  const dropdown = useRef<any>(null);

  const isAdminDashboard = useMemo(() => {
    return location.pathname.startsWith('/admin') || location.pathname == '/';
  }, [location]);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  useEffect(() => {
    const clickHandler = ({ target }: MouseEvent) => {
      if (!dropdown.current) return;
      if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) {
        return;
      }
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }: KeyboardEvent) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  return (
    <div className="relative">
      <button
        ref={trigger}
        onClick={toggleDropdown}
        className="flex items-center gap-2 hover:opacity-80"
        data-testid="menu-button"
      >
        <span className="text-base text-white font-normal">{storeName}</span>
        <svg
          className={cn("transition-transform duration-200", {
            "rotate-180": dropdownOpen,
          })}
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1L5 5L9 1"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* <!-- Dropdown --> */}
      <div
        ref={dropdown}
        className={cn(
          "absolute right-0 mt-4 flex w-62.5 flex-col rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark dark:text-white",
          {
            hidden: !dropdownOpen,
          }
        )}
      >
        <UserMenuItems setMobileMenuOpen={toggleDropdown} />
      </div>
    </div>
  );
};

export default DropdownUser;